import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRouter } from "../context/Router";
import { focusManager } from "../utils/Focus";
import { useAuth } from "../context/Auth";
import { AuthScreen } from "../screens/AuthScreen/AuthScreen";
import { HomeScreen } from "../screens/HomeScreen/HomeScreen";
import { ProfilesScreen } from "../screens/ProfilesScreen/ProfilesScreen";
import { MoviesScreen } from "../screens/MoviesScreen/MoviesScreen";
import { SearchScreen } from "../screens/SearchScreen/SearchScreen";
import { CaveaAuthScreen } from "../screens/AuthScreen/CaveaAuth/CaveaAuthScreen";
import { SilkAuthScreen } from "../screens/AuthScreen/SilkAuth/SilkAuthScreen";
import { fetchUser, logout, updateChosenProfile, } from "../services/user.service";
import { WatchScreen } from "../screens/Player/WatchScreen";
import { BlockMoviesScreen } from "../screens/BlockMoviesScreen/BlockMoviesScreen";
import { InfoModal } from "./views/modals/InfoModal";
import { clearIdsForSTB, isSTBSessionStale } from "../utils/Helpers";
var STALE_LOGOUT_WAIT_MS = 5000;
export var Routes = function () {
    var _a = useRouter(), route = _a.route, params = _a.params, navigate = _a.navigate;
    var _b = useAuth(), user = _b.user, dispatch = _b.dispatch, profile = _b.profile;
    var _c = useTranslation(), t = _c.t, i18n = _c.i18n;
    var userFetched = useRef(false);
    var isSessionStale = useState(isSTBSessionStale)[0];
    var staleLogoutRequest = useRef();
    // Stored IDs are cleared only after a successful logout, so a failed
    // request leaves the mismatch in place for the next launch to retry.
    useEffect(function () {
        if (!isSessionStale) {
            return;
        }
        staleLogoutRequest.current = logout()
            .then(function () {
            clearIdsForSTB();
            dispatch({ type: "LOGOUT" });
        })
            .catch(function (error) { return console.log("Stale session logout failed", error); });
    }, []);
    var handleSessionEndedClose = function () {
        var closeApp = function () { return window.close(); };
        if (!staleLogoutRequest.current) {
            closeApp();
            return;
        }
        var logoutWaitLimit = new Promise(function (resolve) {
            return setTimeout(resolve, STALE_LOGOUT_WAIT_MS);
        });
        Promise.race([staleLogoutRequest.current, logoutWaitLimit]).then(closeApp);
    };
    // Release the per-container scroll/layout caches when navigating. focusManager
    // keeps each screen's scroll container in its offsets/parentRects maps and
    // never prunes them, so a left screen's detached container stays pinned —
    // keeping its whole poster subtree (and textures) alive. Focus groups
    // themselves self-clean via useFocusable's unregister, so we must NOT touch
    // them here (doing so breaks focus on the incoming screen).
    useEffect(function () {
        return function () {
            focusManager.clearScrollCaches();
        };
    }, [route]);
    useEffect(function () {
        if (isSessionStale) {
            return;
        }
        if (!user && route !== "auth" && userFetched.current) {
            navigate("auth");
            return;
        }
        if (user && profile) {
            return;
        }
        fetchUser().then(function (data) {
            dispatch({ type: "SET_PROFILES", profiles: data.profiles });
            var profiles = data.profiles;
            var profileId = data.chosenProfileId;
            var profile;
            if (!profileId) {
                if (profiles.length === 1) {
                    profile = profiles[0];
                    updateChosenProfile(profile.id).then(function () {
                        dispatch({ type: "SET_PROFILE", profile: profile });
                        navigate("home");
                    });
                }
                else {
                    navigate("profiles");
                }
            }
            else {
                profile = profiles.find(function (p) { return p.id === profileId; });
                dispatch({ type: "SET_PROFILE", profile: profile });
                navigate("home");
            }
            userFetched.current = true;
            if (!user) {
                dispatch({ type: "LOGIN", user: data.user });
            }
        }, function () {
            dispatch({ type: "LOGOUT" });
            navigate("auth");
        });
    }, [user]);
    // No focusManager.pushLayer here: it runs after CloseButtonView has
    // registered and swaps in empty groups, leaving Close unfocusable.
    if (isSessionStale) {
        return (React.createElement("div", { id: "modal-overlay", tabIndex: 0, className: "modal-overlay" },
            React.createElement(InfoModal, { text: t("session_ended.text"), onClose: handleSessionEndedClose })));
    }
    switch (route) {
        case "home":
            return React.createElement(HomeScreen, null);
        case "movies":
            return React.createElement(MoviesScreen, { key: "movies" });
        case "tv-shows":
            return React.createElement(MoviesScreen, { key: "tv-shows" });
        case "watch":
            return React.createElement(WatchScreen, null);
        case "auth":
            return React.createElement(AuthScreen, null);
        case "auth-silk":
            return React.createElement(SilkAuthScreen, null);
        case "auth-cavea":
            return React.createElement(CaveaAuthScreen, null);
        case "profiles":
            return React.createElement(ProfilesScreen, null);
        case "search":
            return React.createElement(SearchScreen, null);
        case "see-more":
            // Remount on slug/language change so the fetch starts from a clean state.
            return React.createElement(BlockMoviesScreen, { key: params.slug + "-" + i18n.language });
        default:
            return React.createElement(HomeScreen, null);
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Routes.tsx
// module id = 106
// module chunks = 1